import { UsersAvatarsCategoryComponent } from './users-avatars-category/users-avatars-category.component';

export * from './users-avatars-category/users-avatars-category.component';

export const uiWidgetsExports = [UsersAvatarsCategoryComponent];

export const uiWidgetsDeclarations = [...uiWidgetsExports];
